<template>
  <div>
    <portfolio-screen-motto :project="project"></portfolio-screen-motto>
    <portfolio-about :project="project"></portfolio-about>
    <portfolio-project-team :project="project"></portfolio-project-team>
    <portfolio-interface :project="project" :key="project.getId()"></portfolio-interface>
    <another-projects :projects="anotherProjects"></another-projects>
    <text-us></text-us>
    <contact-modal-form></contact-modal-form>
    <!--block-->
  </div>
</template>

<script>
import PortfolioScreenMotto from "../components/portfolio/blocks/PortfolioScreenMotto";
import PortfolioProjectTeam from "../components/portfolio/blocks/PortfolioProjectTeam";
import PortfolioAbout from "../components/portfolio/blocks/PortfolioAbout";
import stringsKeys from "../i18n/strings.json";
import projects from "../data/projects.json";
import {fromJson} from "../components/portfolio/PortfolioProject";
import PortfolioInterface from "../components/portfolio/blocks/PortfolioInterface";
import AnotherProjects from "../components/common/AnotherProjects";
import TextUs from "../components/common/TextUs";
import ContactModalForm from "../components/common/ContactModalForm";

export default {
  components: {
    ContactModalForm,
    TextUs,
    AnotherProjects,
    PortfolioScreenMotto,
    PortfolioProjectTeam,
    PortfolioInterface,
    PortfolioAbout
  },
  metaInfo() {
    return {
      title: `${this.$t(this.project.title)} - Gemark`,
      meta: [
        {
          name: 'description',
          content: `${this.$t(this.project.title)} - Gemark`
        },
      ]
    }
  },
  computed: {
    portfolioAlias() {
      return this.$route.params.id;
    },
    project() {
      return this.portfolioList.find(obj => {
        return obj.id === this.portfolioAlias
      });
    },
    anotherProjects() {
      return [...this.portfolioList].filter(item => item.getId() !== this.project.getId())
          .sort(() => Math.random() - Math.random())
          .slice(0, 3);
    },
  },
  data: () => {
    return {
      locale: stringsKeys,
      portfolioList: fromJson(projects),
    }
  },
}
</script>

<style scoped>

</style>